import React from 'react';
import PropTypes from "prop-types";
export var EuiHeaderSectionsProp = () => <div />;
EuiHeaderSectionsProp.propTypes = {
  /**
     * An arry of items that will be wrapped in a #EuiHeaderSectionItem
     */
  items: PropTypes.arrayOf(PropTypes.node.isRequired),

  /**
     * Apply the passed border side to each #EuiHeaderSectionItem
     */
  borders: PropTypes.oneOf(["left", "right", "none"]),

  /**
     * Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.
     * Simply pass the array of EuiBreadcrumb objects
     */
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,

    /**
       * Visible label of the breadcrumb
       */
    text: PropTypes.node.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,

    /**
       * Force a max-width on the breadcrumb text
       */
    truncate: PropTypes.bool
  }).isRequired),

  /**
     * Other props to pass to #EuiHeaderBreadcrumbs
     */
  breadcrumbProps: PropTypes.any
};

try {
  EuiHeaderSectionsProp.__docgenInfo = {
    description: '',
    displayName: 'EuiHeaderSectionsProp',
    methods: [],
    props: {
      items: {
        defaultValue: null,
        description: 'An arry of items that will be wrapped in a #EuiHeaderSectionItem',
        name: 'items',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        required: false,
        type: {
          name: 'ReactNode[]'
        }
      },
      borders: {
        defaultValue: null,
        description: 'Apply the passed border side to each #EuiHeaderSectionItem',
        name: 'borders',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        required: false,
        type: {
          name: 'enum',
          raw: '"none" | "left" | "right"',
          value: [{
            value: '"none"'
          }, {
            value: '"left"'
          }, {
            value: '"right"'
          }]
        }
      },
      breadcrumbs: {
        defaultValue: null,
        description: 'Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.\nSimply pass the array of EuiBreadcrumb objects',
        name: 'breadcrumbs',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        required: false,
        type: {
          name: 'EuiBreadcrumb[]'
        }
      },
      breadcrumbProps: {
        defaultValue: null,
        description: 'Other props to pass to #EuiHeaderBreadcrumbs',
        name: 'breadcrumbProps',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        required: false,
        type: {
          name: 'Pick<EuiBreadcrumbsProps, "className" | "aria-label" | "data-test-subj" | "max" | "responsive" | "truncate">'
        }
      }
    },
    extendedInterfaces: ['EuiHeaderSections']
  };
} catch (e) {}